export default {
  // request_url:'/api/',
  request_url:'http://admin.nbdsjgxx.com/api/',
}



//////////////////
// WEBPACK FOOTER
// ./static/conf.js
// module id = null
// module chunks = 